var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass:
            "pt-3 l-m-b-20 align-items-center d-flex justify-content-between blocks"
        },
        [
          _c("div", { staticClass: "d-flex align-items-center" }, [
            _c("h1", { staticClass: "pr-3 w-full" }, [_vm._v("Contracts")]),
            _vm._v(" "),
            _c("div", { staticClass: "input-group search" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.q,
                    expression: "q"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "text", placeholder: "Search" },
                domProps: { value: _vm.q },
                on: {
                  keyup: function($event) {
                    _vm.searchText($event)
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.q = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn input-group-btn",
                  attrs: { type: "button" },
                  on: { click: _vm.clearSearch }
                },
                [_c("i", { class: [_vm.q ? "fa fa-remove" : "fa fa-search"] })]
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-right" },
            [
              _c(
                "router-link",
                {
                  staticClass: "btn btn-primary btn-schedule",
                  attrs: { tag: "button", to: "/contracts/create" }
                },
                [
                  _c("div", { staticClass: "fa fa-plus-square pr-1" }),
                  _vm._v("\n        Create contract\n      ")
                ]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.contentLoading
        ? [
            _c(
              "vue-content-loading",
              { attrs: { width: 800, height: 450 } },
              _vm._l(15, function(x) {
                return _c("rect", {
                  key: x,
                  attrs: {
                    x: "10",
                    y: 15 * x * 1.4,
                    rx: "5",
                    ry: "5",
                    width: "720",
                    height: "6"
                  }
                })
              })
            )
          ]
        : [
            _c(
              "div",
              { staticClass: "blocks" },
              _vm._l(_vm.contracts, function(contract, index) {
                return _c("ContractsBlock", {
                  key: index,
                  attrs: { contract: contract },
                  on: {
                    "update:contract": function($event) {
                      contract = $event
                    }
                  }
                })
              })
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "row blocks" },
              [
                _vm.meta.total
                  ? _c(
                      "div",
                      { staticClass: "col-sm-6 mb-1 text-black-50 pl-0" },
                      [
                        _vm._v(
                          "\n        Showing " +
                            _vm._s(_vm.meta.from) +
                            " - " +
                            _vm._s(_vm.meta.to) +
                            " of " +
                            _vm._s(_vm.meta.total) +
                            "\n      "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("pagination", {
                  staticClass: "col-sm-6 mb-1 pr-0",
                  attrs: { "change-page": _vm.changePage, meta: _vm.meta }
                })
              ],
              1
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-11162f33", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11162f33","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contracts/Contracts.vue
// module id = null
// module chunks = 